import * as React from 'react';
import styled from 'styled-components';
import { COLORS, ComponentTextStyle, ComponentXSStyling } from '..';

const Container = styled.div<{$variant: TagVariants, $isLabelPresent: boolean}>`
  display: flex;
  padding: 4px;
  height: 24px;
  width: calc(100%);
  max-width: fit-content;
  align-items: center;
  justify-content: center;
  min-width: ${props=>props.$isLabelPresent ? '64px' : ''};
  border-radius: 2px;
  box-sizing: border-box;

  &.neutral {
    background-color: ${props => COLORS.generateToken({ componentType: 'bg-surface', defaultVariant: 'neutral' }, props.theme)};
    color: ${props => COLORS.generateToken({ componentType: 'text', defaultVariant: 'neutral' }, props.theme)};
  }
  &.positive {
    background-color: ${props => COLORS.generateToken({ componentType: 'bg-surface', defaultVariant: 'positive' }, props.theme)};
    color: ${props => COLORS.generateToken({ componentType: 'text', defaultVariant: 'positive' }, props.theme)};
  }
  &.warning {
    background-color: ${props => COLORS.generateToken({ componentType: 'bg-surface', defaultVariant: 'warning' }, props.theme)};
    color: ${props => COLORS.generateToken({ componentType: 'text', defaultVariant: 'warning' }, props.theme)};
  }
  &.critical {
    background-color: ${props => COLORS.generateToken({ componentType: 'bg-surface', defaultVariant: 'critical' }, props.theme)};
    color: ${props => COLORS.generateToken({ componentType: 'text', defaultVariant: 'critical' }, props.theme)};
  }
  &.accent1 {
    background-color: ${props => COLORS.generateToken({ componentType: 'bg-surface', defaultVariant: 'accent1' }, props.theme)};
    color: ${props => COLORS.generateToken({ componentType: 'text', defaultVariant: 'accent1' }, props.theme)};
  }
  &.accent2 {
    background-color: ${props => COLORS.generateToken({ componentType: 'bg-surface', defaultVariant: 'accent2' }, props.theme)};
    color: ${props => COLORS.generateToken({ componentType: 'text', defaultVariant: 'accent2' }, props.theme)};
  }

`;

const IconContainer = styled.div<{$variant: TagVariants}>`
  display: flex;
  width: 16px;
  height: 16px;
  svg {
    width: 16px;
    height: 16px;
  }
`;

const TextContainer = styled.div<{$variant: TagVariants, $icon: React.ReactNode}>`
  height: 16px;
  padding: 0 4px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;  
  ${ComponentXSStyling(ComponentTextStyle.Bold, null)}
`;


export type TagVariants = 'neutral' | 'positive' | 'warning' | 'critical' | 'accent1' | 'accent2';

export type TagProps = React.HTMLAttributes<HTMLDivElement> & {
  /** Optional. Label to be shown in the Tag. */
  label?: string;
  /** Optional. Icon to be shown in the tag. */
  icon?: React.ReactNode;
  /** Optional. Style Variant of the Tag. Defaults to 'neutral' */
  variant?: TagVariants;
}

const Tag: React.FunctionComponent<TagProps> = ({label, icon, variant='neutral', className, ...rest}) => {
  const cls = `${className ?? ''} ${variant}`;
  return (   
    <Container $variant={variant} $isLabelPresent={!!label} className={cls} {...rest}>
      {icon && <IconContainer $variant={variant} data-testid={'iconContainer'}>
          {icon}
        </IconContainer>
      }
      {label && <TextContainer $variant={variant} $icon={icon}>
          {label}
        </TextContainer>
      }
    </Container>
  );
};

export default Tag;
